import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import styles from '../shared/styles';
import DrippingInput from '../soundcast/drippinginput';
import { DivisionLabel } from '../shared/styled-components';
import { canUserAccessFeature } from '../../../../helpers/userinfoHelper';

const ReleaseInterval = props => {
  const { label, value, required, onChange } = props;
  const requiredRender = required ? <span style={styles.inputLabelRequire}>*</span> : null;
  if (!canUserAccessFeature('EPISODE_DRIPPING')) {
    return null;
  }

  return (
    <div className="row" style={styles.rowDivision}>
      <div className="col-lg-9 col-md-9 col-sm-12 col-xs-12">
        <DivisionLabel>
          {label} {requiredRender}
        </DivisionLabel>
        <div className="text-medium margin-one-half-bottom">
          The drip days is counted from the day the listener signs up
        </div>
        <InputWrapper>
          <DrippingInput value={value} onChange={onChange} />
          <span className="text-large margin-one-half-left">days</span>
        </InputWrapper>
      </div>
    </div>
  );
};

const InputWrapper = styled.div`
  .drip-input-delay {
    margin: 0;
    font-size: 1.6rem;
    max-width: 100px;
    border-radius: 4px;
  }
`;

ReleaseInterval.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
};

ReleaseInterval.defaultProps = {
  label: 'Dripping Interval',
  value: 0,
  required: false,
  placeholder: '',
  onChange: () => {},
};

export default ReleaseInterval;
